namespace $ {
	const $shm_hitalama_map_event_results = new WeakMap< Event, Map< string, unknown > >
	const $shm_hitalama_map_event_ids = new WeakMap< Event, string >
	let $shm_hitalama_map_event_sequence = 0

	export function $shm_hitalama_map_event_key( event: Event, command: string ) {
		let id = $shm_hitalama_map_event_ids.get( event )
		if( !id ) {
			id = `${ event.type }:${ event.timeStamp }:${ ++ $shm_hitalama_map_event_sequence }`
			$shm_hitalama_map_event_ids.set( event, id )
		}
		return `${ id }:${ command }`
	}

	export function $shm_hitalama_map_event_claim( event: Event, command: string ) {
		let results = $shm_hitalama_map_event_results.get( event )
		if( !results ) $shm_hitalama_map_event_results.set( event, results = new Map )
		if( results.has( command ) ) return null
		results.set( command, null )
		return $shm_hitalama_map_event_key( event, command )
	}

	export function $shm_hitalama_map_event_once< Result >( event: Event, command: string, task: ()=> Result ): Result {
		let results = $shm_hitalama_map_event_results.get( event )
		if( !results ) $shm_hitalama_map_event_results.set( event, results = new Map )
		if( results.has( command ) ) return results.get( command ) as Result
		const result = task()
		results.set( command, result )
		return result
	}

	type $shm_hitalama_map_widget_add_batch = {
		slots: Map< string, $shm_hitalama_map_widget_add_state >
		before: Set< string >
		done: boolean
		result?: unknown
	}

	const $shm_hitalama_map_widget_add_batches = new Map< string, $shm_hitalama_map_widget_add_batch >
	const $shm_hitalama_map_widget_add_active = new Map< string, $shm_hitalama_map_widget_add_batch >
	const $shm_hitalama_map_widget_add_fibers = new WeakMap< object, $shm_hitalama_map_widget_add_batch >
	const $shm_hitalama_map_widget_make_states = new Map< string, $shm_hitalama_map_widget_add_state >

	class $shm_hitalama_map_widgets extends $giper_baza_list_link.to( ()=> $shm_hitalama_map_widget ){ }
	class $shm_hitalama_map_widgets_reference extends $giper_baza_entity.with({
		Widgets: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widgets ),
		Version: $giper_baza_atom_real,
	}) {}

	class $shm_hitalama_map_widget_add_state extends $mol_object {
		list(): $shm_hitalama_map_widgets { throw new Error( 'Not implemented' ) }
		land(): $giper_baza_land { throw new Error( 'Not implemented' ) }
		readonly area_idea = Math.floor( Math.random() * 2**48 )
		widget_title?: string
		widget: $shm_hitalama_map_widget | null = null
		before = new Set< string >
		done = false

		title( type: $shm_hitalama_map_widget_def_type_name ) {
			return this.widget_title || $shm_hitalama_inc_name(
				this.list().remote_list().map( widget => widget.title() ),
				$shm_hitalama_map_widget_def_titles[ type ] || type,
			)
		}

		@ $mol_mem
		area() {
			// `area_make()` may suspend while loading rights. Its default random
			// argument would point every restart at a different area, so keep the
			// idea on the durable command state.
			return this.land().area_make( this.area_idea )
		}

		@ $mol_mem
		make() {
			const area = this.area()
			const widget = area.Pawn( $shm_hitalama_map_widget ).Data()
			if( $shm_hitalama_map_widget.meta ) widget.meta( $shm_hitalama_map_widget.meta )
			return widget
		}
	}

	type $shm_hitalama_map_widget_cut_item = {
		widget: $shm_hitalama_map_widget
		container: string
		files: readonly $giper_baza_link[]
		title: string
		type: string
	}

	type $shm_hitalama_map_widget_relations = {
		parents: ReadonlyMap< string, $shm_hitalama_map_widget >
		children: ReadonlyMap< string, readonly $shm_hitalama_map_widget[] >
	}

	export class $shm_hitalama_map extends $giper_baza_entity.with({

		Widgets: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widgets ),
		// Widgets: $giper_baza_list_link.to( ()=> $shm_hitalama_map_widget ),

		Widget_by_name: $giper_baza_dict_to( $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ) ),
		
		Widgets_removed: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widgets ),

		Created_at: $giper_baza_atom_real,
		Changed_at: $giper_baza_atom_real,

		Access_level: $giper_baza_atom_text, //private, public_read, public_edit
		Version: $giper_baza_atom_real,

		Last_color: $giper_baza_atom_text,
		Last_font_size: $giper_baza_atom_real,

		Last_width: $giper_baza_atom_real,
		Last_height: $giper_baza_atom_real,

		Search_statistics: $giper_baza_list_link.to( ()=> $shm_hitalama_map_widget_entity_form ),

		Files: $giper_baza_list_link.to( ()=> $shm_hitalama_file ),

		Tables: $giper_baza_list_link.to( ()=> $shm_hitalama_map_widget_entity_table ),
		Datasets: $giper_baza_list_link.to( ()=> $shm_hitalama_map_widget_entity_table2_dataset ),

		Charts: $giper_baza_list_link.to( ()=> $shm_hitalama_map_widget_entity_chart ),

		Description: $giper_baza_atom_text,

		Presences: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_presence_dict ),

		Customs: $giper_baza_list_link.to( ()=> $shm_hitalama_map_widget_entity_custom ),

		Slideshow_enabled: $giper_baza_atom_bool,
		Camera_locked: $giper_baza_atom_bool,
		Slideshow_frame: $giper_baza_atom_real,

		Backup_time: $giper_baza_atom_real,

		Store_json: $giper_baza_atom_dict,
		Journal_snapshots: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_journal_snapshots ),
		History: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_history ),
		History_legacy: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_history ),

	}){

		can_read() {
			const land = this.land().sync()
			return land.pass_rank( land.auth().pass() ) >= $giper_baza_rank_read
		}

		// Delegate to the reactive atom directly. A write before the first read
		// must not cache a second, dependency-free copy of the title on the map.
		override title = ( next?: string ) => {
			return this.Title( next )?.val( next ) ?? ''
		}

		@ $mol_mem
		summary(): $shm_hitalama_map_summary_data {
			return {
				title: this.title() || this.link().str,
				changed_at: this.Changed_at()?.val() ?? 0,
				created_at: this.Created_at()?.val() ?? 0,
				access_level: this.access_level(),
			}
		}

		@ $mol_action
		summary_publish() {
			const profile = this.$.$shm_hitalama_profile.current()
			if( !profile ) return this.summary()
			profile.map_summary( this.link().str, this.summary() )
			return this.summary()
		}

		static access_level_to_ranks() {
			return {
				'private': [[ null, $giper_baza_rank_deny ]],
				'public_read': [[ null, $giper_baza_rank_read ]],
				'public_edit': [[ null, $giper_baza_rank_rule ]],
			}
		} 

		@ $mol_action
		static make_new( title: string, access_level: keyof ReturnType<typeof $shm_hitalama_map.access_level_to_ranks> ) {
			const ranks = this.access_level_to_ranks()[ access_level ] as any as $giper_baza_rank_preset
			const land = this.$.$giper_baza_glob.land_grab( ranks )
			return this.make_in_land( land, title, access_level )
		}

		static access_level_title( level: string ) {
			return ({
				private: 'Приватная карта',
				public_read: 'Публичная карта — только чтение',
				public_edit: 'Публичная карта — редактируемая',
				fast: 'Локальная карта',
			} as Record< string, string >)[ level ] ?? 'Тип карты не указан'
		}

		@ $mol_action
		static make_in_land( land: $giper_baza_land, title: string, access_level: string ) {
			const map = land.Data( $shm_hitalama_map )
			const time = ( new $mol_time_moment ).valueOf()
			map.title( title )
			map.Created_at(null)?.val( time )
			map.Changed_at(null)?.val( time )
			map.access_level( access_level )
			map.version( $shm_hitalama_map_migration.latest_version() )
			return map
		}

		@ $mol_action
		static make_fast( title: string ) {
			const land_make = ( this.$ as any ).$rise_baza_patch_land_make as
				| undefined
				| ( ( Pawn: typeof $giper_baza_pawn, context?: any )=> $giper_baza_land )
			
			if( !land_make ) return $mol_fail( new Error( '$rise_baza_patch_land_make is not available' ) )
			
			const land = land_make( $shm_hitalama_map, this.$ )
			const map = land.Data( $shm_hitalama_map )
			const time = ( new $mol_time_moment ).valueOf()
			map.title( title )
			map.Created_at(null)?.val( time )
			map.Changed_at(null)?.val( time )
			map.access_level( 'fast' )
			map.version( $shm_hitalama_map_migration.latest_version() )
			return map
		}

		@ $mol_mem_key
		temp_store( key: string, next?: any ) {
			$mol_wire_solid()
			return next
		}

		journal_snapshots() {
			return $shm_hitalama_map_journal_recorder.journal( this )
		}

		@ $mol_mem
		history_reference() {
			const land = this.land().area_make( $mol_hash_string( `${ this.link().str }:history-reference` ) )
			return land.Data( $shm_hitalama_map_history_reference )
		}

		@ $mol_mem
		widgets_reference() {
			const land = this.land().area_make( $mol_hash_string( `${ this.link().str }:widgets-reference` ) )
			return land.Data( $shm_hitalama_map_widgets_reference )
		}

		@ $mol_action
		widgets_reference_publish( list: $shm_hitalama_map_widgets, version = $shm_hitalama_map_migration.latest_version() ) {
			// Publishing is an explicit command, never an inference from a missing
			// remote value: sync() loads IDB but does not await the master. A cold
			// reader must not overwrite the newer reference with the legacy pointer.
			const reference = this.widgets_reference()
			reference.land().sync()
			if( reference.Widgets()?.remote()?.link().str !== list.link().str ) reference.Widgets( null )?.remote( list )
			if( reference.Version()?.val() !== version ) reference.Version( null )?.val( version )
			return reference.Widgets()?.remote() ?? null
		}

		@ $mol_action
		history_reference_publish() {
			this.land().sync()
			const current = this.History()?.remote()
			if( !current ) return null
			const reference = this.history_reference()
			reference.land().sync()
			if( reference.History()?.remote()?.link().str !== current.link().str ) {
				reference.History( null )?.remote( current )
			}
			current.map_bind( this, false )
			return current
		}

		@ $mol_mem
		history_maybe() {
			// New clients resolve this tiny deterministic pointer first. Unlike the
			// historical map field it does not compete with large map/history lands.
			const referenced = this.history_reference().History()?.remote()
			if( referenced ) {
				referenced.map_bind( this, false )
				return referenced
			}
			// Do not mistake a not-yet-loaded root land for a map without history:
			// creating a replacement at that point races the server value on a cold client.
			this.land().sync()
			const current = this.History()?.remote()
			// Keep the local backlink without touching the potentially large legacy
			// history root. Compact metadata and target shards are deterministic lands.
			current?.map_bind( this, false )
			return current ?? null
		}

		@ $mol_mem
		history() {
			const current = this.history_maybe()
			if( current ) {
				// Creating the reference may suspend after the history itself has already
				// been stored. Finish this second idempotent write on the restarted fiber.
				if( this.version() >= 16 ) {
					const reference = this.history_reference()
					reference.land().sync()
					if( reference.History()?.remote()?.link().str !== current.link().str ) {
						reference.History( null )?.remote( current )
					}
				}
				// A recent map schema does not prove that a legacy history tail has been
				// copied out of its shared land. Do not hide it before that migration.
				return current
			}

			this.History( null )
			const history = this.History()?.ensure( this.land() )
			if( !history ) throw new Error( 'Не удалось открыть хранилище истории карты' )
			history.map_bind( this )
			const reference = this.history_reference()
			reference.land().sync()
			reference.History( null )?.remote( history )
			// A newly created history has no legacy tail by definition. Persist this
			// fact in the compact metadata land so cold readers never inspect its root.
			history.storage_migrated( true )
			return history
		}

		@ $mol_action
		file_make() {
			// Reading an existing field with `auto` needlessly writes its dictionary key.
			// In a wire render this can invalidate the same read and briefly return null.
			this.land().sync()
			let files = this.Files()
			if( !files ) {
				this.Files( null )
				files = this.Files()
			}
			return files?.make( this.land() ) ?? null
		}

		@ $mol_action
		file_make_stable( key: string ) {
			this.land().sync()
			let files = this.Files()
			if( !files ) {
				this.Files( null )
				files = this.Files()
			}
			if( !files ) return null
			const land = this.land().area_make( $mol_hash_string( `${ this.link().str }:file:${ key }` ) )
			const file = land.Data( $shm_hitalama_file )
			if( !files.has( file.link() ) ) files.add( file.link() )
			return file
		}

		history_events() {
			return this.history_maybe()?.events() ?? []
		}

		history_undo() {
			return this.history().undo()
		}

		history_redo() {
			return this.history().redo()
		}

		@ $mol_mem_key
		store( key: string, next?: any ) {
			const obj: any = this.Store_json(null)?.val() ?? {}
			if( next === undefined ) return obj[key]

			this.Store_json(null)?.val( {...obj, [key]: next} )
			return next
		}

		@ $mol_action
		store_async( key: string, next?: any ) {
			if( next === undefined ) return structuredClone( this.store( key ) )
			return this.store( key, next )
		}

		@ $mol_mem_key
		widget_by_link( ref: $giper_baza_link ) {
			return this.$.$giper_baza_glob.Pawn( ref, $shm_hitalama_map_widget )
		}
		
		@ $mol_mem_key
		widget( ref: string ) {
			try {
				return this.widget_by_link( new $giper_baza_link( ref ) )
			} catch (error) {
				const by_name = this.Widgets_list()?.remote_list().find( b => b.title() == ref )
				if( !by_name ) throw new Error(`Widget "${ref}" isn't exist (neither ref nor name)`)
				return by_name
			}
		}

		/** The persisted creation index is only a hint: titles can change independently. */
		@ $mol_mem_key
		widget_by_title( title: string ) {
			const list = this.Widgets_list()
			if( !list ) return null
			const indexed = this.Widget_by_name()?.key( title )?.remote()
			if( indexed && list.has( indexed.link() ) && indexed.title() === title ) return indexed
			return list.remote_list().find( widget=> widget.title() === title ) ?? null
		}

		version( next?: number ) {
			return this.Version( next )?.val( next ) ?? 0
		}

		Widgets_list(auto?: null): $shm_hitalama_map_widgets | null {
			const reference = this.widgets_reference()
			reference.land().sync()
			const referenced = reference.Widgets()?.remote()
			if( referenced && typeof ( referenced as any ).remote_list === 'function' ) return referenced
			this.land().sync()
			const slot = this.Widgets()
			const list = slot?.remote()
			if( list && typeof ( list as any ).remote_list === 'function' ) {
				return list
			}

			if( auto !== null ) return null

			const area = this.land().area_make()
			const fresh = this.$.$giper_baza_glob.Pawn( area.link(), $shm_hitalama_map_widgets )
			this.Widgets(null)?.remote( fresh )
			reference.Widgets( null )?.remote( fresh )
			reference.Version( null )?.val( $shm_hitalama_map_migration.latest_version() )
			return fresh
		}
		private readonly widgets_removed_area_idea = Math.floor( Math.random() * 2**48 )

		@ $mol_mem
		widgets_removed_area() {
			return this.land().area_make( this.widgets_removed_area_idea )
		}

		Widgets_removed_list(auto?: null): $shm_hitalama_map_widgets | null {
			const slot = this.Widgets_removed()
			const list = slot?.remote()
			if( list && typeof ( list as any ).remote_list === 'function' ) return list

			if( auto !== null ) return null

			const area = this.widgets_removed_area()
			const fresh = this.$.$giper_baza_glob.Pawn( area.link(), $shm_hitalama_map_widgets )
			this.Widgets_removed(null)?.remote( fresh )
			return fresh
		}

		/** Consistent relation view built only from reciprocal links between live widgets. */
		private widget_children_stored( parent: $shm_hitalama_map_widget ) {
			return ( parent.Widgets()?.remote_list() ?? [] )
				.map( child => child.cast( $shm_hitalama_map_widget ) )
		}

		@ $mol_mem
		widget_relations(): $shm_hitalama_map_widget_relations {
			const widgets = this.Widgets_list()?.remote_list() ?? []
			const by_id = new Map( widgets.map( widget => [ widget.link_str(), widget ] ) )
			const candidates = new Map< string, $shm_hitalama_map_widget[] >

			for( const parent of widgets ) {
				const parent_id = parent.link_str()
				for( const child of this.widget_children_stored( parent ) ) {
					const child_id = child.link_str()
					if( child_id === parent_id || !by_id.has( child_id ) ) continue
					const list = candidates.get( child_id ) ?? []
					if( !list.some( item => item.link_str() === parent_id ) ) list.push( parent )
					candidates.set( child_id, list )
				}
			}

			const parents = new Map< string, $shm_hitalama_map_widget >
			for( const child of widgets ) {
				const list = candidates.get( child.link_str() ) ?? []
				if( !list.length ) continue
				const declared = child.container_widget()?.link_str()
				parents.set( child.link_str(), list.find( parent => parent.link_str() === declared ) ?? list[0] )
			}

			// Corrupted or concurrently delivered operations may form a cycle. Detach
			// one deterministic member so every live widget remains reachable.
			for( let changed = true; changed; ) {
				changed = false
				for( const widget of widgets ) {
					const path: string[] = []
					const offsets = new Map< string, number >
					let current = widget.link_str()
					while( parents.has( current ) ) {
						const offset = offsets.get( current )
						if( offset !== undefined ) {
							const detached = path.slice( offset ).toSorted().at( -1 )!
							parents.delete( detached )
							changed = true
							break
						}
						offsets.set( current, path.length )
						path.push( current )
						current = parents.get( current )!.link_str()
					}
					if( changed ) break
				}
			}

			const children = new Map< string, $shm_hitalama_map_widget[] >(
				widgets.map( widget => [ widget.link_str(), [] ] )
			)
			for( const parent of widgets ) {
				const parent_id = parent.link_str()
				const added = new Set< string >
				for( const child of this.widget_children_stored( parent ) ) {
					const child_id = child.link_str()
					if( added.has( child_id ) || parents.get( child_id )?.link_str() !== parent_id ) continue
					added.add( child_id )
					children.get( parent_id )!.push( by_id.get( child_id )! )
				}
			}

			return { parents, children }
		}

		widget_container_actual( widget: $shm_hitalama_map_widget ) {
			return this.widget_relations().parents.get( widget.link_str() ) ?? null
		}

		widget_children_actual( widget: $shm_hitalama_map_widget ) {
			return this.widget_relations().children.get( widget.link_str() ) ?? []
		}

		/** Union of both stored relation directions, used by destructive commands. */
		widget_children_linked( parent: $shm_hitalama_map_widget ) {
			const widgets = this.Widgets_list()?.remote_list() ?? []
			const live = new Map( widgets.map( widget => [ widget.link_str(), widget ] ) )
			const parent_id = parent.link_str()
			const result = new Map< string, $shm_hitalama_map_widget >
			for( const child of this.widget_children_stored( parent ) ) {
				const current = live.get( child.link_str() )
				if( current && current.link_str() !== parent_id ) result.set( current.link_str(), current )
			}
			for( const child of widgets ) {
				if( child.link_str() === parent_id ) continue
				if( child.container_widget()?.link_str() === parent_id ) result.set( child.link_str(), child )
			}
			return [ ... result.values() ]
		}

		/** Repairs persisted links after old bugs or partially delivered CRDT operations. */
		@ $mol_action
		widget_relations_repair() {
			const widgets = this.Widgets_list()?.remote_list() ?? []
			const relations = this.widget_relations()
			let changed = 0

			for( const parent of widgets ) {
				const before = this.widget_children_stored( parent ).map( child => child.link_str() )
				const children = relations.children.get( parent.link_str() ) ?? []
				const after = children.map( child => child.link_str() )
				if( before.length === after.length && before.every( ( id, index )=> id === after[index] ) ) continue
				parent.widgets( [ ... children ] )
				++ changed
			}

			for( const child of widgets ) {
				const before = child.container_widget()?.link_str() ?? ''
				const parent = relations.parents.get( child.link_str() ) ?? null
				if( before === ( parent?.link_str() ?? '' ) ) continue
				child.container_widget( parent )
				++ changed
			}

			return changed
		}
		
		widget_text( ref: string, next?: string ) {
			return this.widget( ref ).text( next )
		}
		
		widget_data( ref: string, next?: any ) {
			return this.widget( ref ).data( next )
		}

		widget_file( ref: string ) {
			const widget = this.widget( ref )
			const file = widget.File()?.remote()
			if( !file ) throw new Error( `No file for widget "${ widget.title() || ref }"` )
			return file
		}

		@ $mol_mem_key
		import_js_file_uri( file: $shm_hitalama_file ) {
			const blob = file.blob()
			if( !blob ) throw new Error( 'Файл не найден' )

			const js_blob = $shm_hitalama_map_widget_entity_app.archive( file )
				? $shm_hitalama_map_widget_entity_app.js_file_from( file )
				: new Blob( [ blob ], { type: 'text/javascript' } )
			return URL.createObjectURL( js_blob )
		}

		@ $mol_mem_key
		import_js_file( file: $shm_hitalama_file ) {
			return $mol_import.module( this.import_js_file_uri( file ) )
		}

		widget_value( ref: string, next?: any ) {
			const widget = this.widget( ref )
			
			const type = widget.type()
			switch (type) {
				case 'code':
				case 'code_js':
				case 'code_ts':
				case 'code_html':
				case 'code_sql': {
					if( next === undefined ) {
						const run_auto = this.widget_code_run_auto( widget )
						if( run_auto ) return run_auto()
					}
					break
				}
				case 'form_custom': {
					if( widget.Data_method()?.val() ) return widget.data( next )
					return widget.form_custom().object_current( next )
				}
				case 'form2': {
					return widget.dataset().object_current( next )
				}
				case 'table_novirt':
				case 'tabulator':
				case 'table': {
					const custom = widget.table().form_custom()
					if( custom ) return custom.objects()
	
					const head = widget.table_head()
					const rows = widget.table_rows()
					return rows.map( r => Object.fromEntries( head.map( (h, i)=> [ h, r[i] ] ) ) )
				}
				case 'table2': {
					return widget.dataset().objects( next )
				}
				case 'autoview':
				case 'application': {
					const data = widget.data() ?? {}
					if( next === undefined ) return data.value
					widget.data({ ... data, value: next })
					return next
				}
				case 'text': {
					if( next === undefined ) return widget.preprocessed()
					return widget.text(next)
				}
				case 'image': {
					return widget.Image()?.blob()
				}
				case 'file': {
					return widget.text()
				}
			}

			return this.execute( widget.code(), { [ '$' + 'arg' ]: next ?? {}, [ '$' + 'this_widget' ]: widget } )
		}

		widget_code_run_auto( widget: $shm_hitalama_map_widget ) {
			const runner = this.runtime().widget_runner( widget.link_str() )
			return ()=> runner.run_auto()
		}

		async widget_value_async( ref: string, next?: any ) {
			const widget = this.widget( ref )

			if( [ 'code', 'code_js', 'code_ts', 'code_html', 'code_sql' ].includes( widget.type() ) ) {
				const run_auto = this.widget_code_run_auto( widget )
				if( run_auto ) return run_auto()
			}

			if( ['form_custom','form2','table','table2','text','image','file'].includes( widget.type() ) ) {
				return this.widget_value( ref, next )
			}

			return await $mol_wire_async( this ).execute_action( widget.code(), { [ '$' + 'arg' ]: next ?? {}, [ '$' + 'this_widget' ]: widget } )
		}

		@ $mol_mem
		access_level( next?: string ){
			return this.Access_level(next)?.val( next ) ?? ''
		}

		@ $mol_mem
		slideshow_enabled( next?: boolean ){
			// if( next ) document.documentElement.requestFullscreen()
			// else if( next === false ) document.exitFullscreen()
			return this.Slideshow_enabled(next)?.val( next ) ?? false
		}
		
		@ $mol_mem
		interaction_locked( next?: boolean ): boolean {
			return this.$.$mol_state_local.value( this.link().str + '.interaction_locked', next ) ?? false
		}

		@ $mol_mem
		camera_locked( next?: boolean ){
			return this.slideshow_enabled()
				|| this.Camera_locked(next)?.val( next )
				|| false
		}

		@ $mol_mem
		backup_time( next?: string ): string {
			if( next === undefined ) return String( this.Backup_time()?.val() || 5 )
			
			this.Backup_time(next)?.val( Number(next) )
			return next
		}

		slideshow_frame( next?: number ) {
			if( next !== undefined ) {
				if( next < 1 ) next = 1
				const max = this.viewport_frames().length
				if( next > max ) next = max
			}
			return this.Slideshow_frame(next)?.val(next) ?? 1
		}
		
		slideshow_frame_str() {
			return String(this.slideshow_frame())
		}

		@ $mol_mem
		viewport_frames_visible( next = true ) {
			return next
		}

		@ $mol_mem
		runtime() {
			$mol_wire_solid()
			return $shm_hitalama_map_runtime.make({
				map: ()=> this,
			})
		}

		@ $mol_mem
		method_runtime() {
			return $shm_hitalama_map_method_runtime.make({
				map: ()=> this,
			})
		}

		@ $mol_mem
		method_app() {
			return this.method_runtime().app()
		}

		@ $mol_mem
		method_source() {
			return this.method_runtime().source()
		}

		extract_reactive_deps( text: string ){
			return this.runtime().extract_reactive_deps( text )
		}

		prepare_html( text: string ) {
			return this.runtime().prepare_html( text )
		}

		execute( code: string, context?: Record< string, any > ) {
			return this.runtime().execute( code, context )
		}

		@ $mol_action
		execute_action( code: string, context?: Record< string, any > ) {
			return this.runtime().execute_action( code, context )
		}

		@ $mol_action
		make_public() {
			this.land().give( null, $giper_baza_rank_read )
		}

		@ $mol_action
		now() {
			return new $mol_time_moment
		}

		@ $mol_action
		widget_make( operation = '' ) {
			if( operation ) {
				const key = `${ this.link().str }:${ operation }`
				let state = $shm_hitalama_map_widget_make_states.get( key )
				if( !state ) {
					state = this.widget_add_state()
					$shm_hitalama_map_widget_make_states.set( key, state )
					if( $shm_hitalama_map_widget_make_states.size > 1024 ) {
						$shm_hitalama_map_widget_make_states.delete( $shm_hitalama_map_widget_make_states.keys().next().value! )
					}
				}
				state.widget ??= state.make()
				const widget = state.widget
				const list = state.list()
				if( widget && !list.has( widget.link() ) ) list.add( widget.link() )
				for( const candidate of list.remote_list() ) {
					const id = candidate.link_str()
					if( state.before.has( id ) || id === widget?.link().str ) continue
					if( candidate.type() !== 'text' || candidate.title() !== id ) continue
					$shm_hitalama_map_history.silence( ()=> list.cut( candidate.link() ) )
				}
				return widget
			}
			const list = this.Widgets_list( null )
			const widget = list?.make( this.land() )
			if( widget && !list?.has( widget.link() ) ) list?.add( widget.link() )
			return widget
		}

		private widget_add_state( name?: string ) {
			const list = this.Widgets_list( null )!
			const land = this.land()
			return $shm_hitalama_map_widget_add_state.make({
				list: ()=> list,
				land: ()=> land,
				widget_title: name,
				before: new Set( list.remote_list().map( widget => widget.link_str() ) ),
			})
		}

		private widget_add_batches = new Map< object | string, $shm_hitalama_map_widget_add_batch >
		private widget_add_batch_current: $shm_hitalama_map_widget_add_batch | null = null
		widget_add_batch< Result >( owner: object | string, task: ()=> Result ) {
			const global_key = typeof owner === 'string' ? `${ this.link().str }:${ owner }` : ''
			let batch = global_key
				? $shm_hitalama_map_widget_add_batches.get( global_key )
				: this.widget_add_batches.get( owner )
			if( !batch ) {
				batch = {
					slots: new Map,
					before: new Set( this.Widgets_list()?.remote_list().map( widget => widget.link_str() ) ?? [] ),
					done: false,
				}
				if( global_key ) {
					$shm_hitalama_map_widget_add_batches.set( global_key, batch )
					if( $shm_hitalama_map_widget_add_batches.size > 256 ) {
						$shm_hitalama_map_widget_add_batches.delete( $shm_hitalama_map_widget_add_batches.keys().next().value! )
					}
				} else {
					this.widget_add_batches.set( owner, batch )
				}
			}
			if( batch.done ) return batch.result as Result
			const previous = this.widget_add_batch_current
			const map_key = this.link().str
			const previous_global = $shm_hitalama_map_widget_add_active.get( map_key )
			this.widget_add_batch_current = batch
			$shm_hitalama_map_widget_add_active.set( map_key, batch )
			try {
				const result = task()
				const expected = new Set( [ ... batch.slots.values() ].flatMap( state => state.widget ? [ state.widget.link().str ] : [] ) )
				const list = this.Widgets_list( null )
				for( const widget of list?.remote_list() ?? [] ) {
					const id = widget.link_str()
					if( batch.before.has( id ) || expected.has( id ) ) continue
					if( widget.type() !== 'text' || widget.title() !== id ) continue
					$shm_hitalama_map_history.silence( ()=> list?.cut( widget.link() ) )
				}
				batch.result = result
				batch.done = true
				return result
			} catch( error ) {
				if( !$mol_promise_like( error ) ) {
					if( global_key ) $shm_hitalama_map_widget_add_batches.delete( global_key )
					else this.widget_add_batches.delete( owner )
				}
				throw error
			} finally {
				this.widget_add_batch_current = previous
				if( previous_global ) $shm_hitalama_map_widget_add_active.set( map_key, previous_global )
				else $shm_hitalama_map_widget_add_active.delete( map_key )
			}
		}

		widget_add(
			type: $shm_hitalama_map_widget_def_type_name,
			pos: readonly [number, number] | readonly number[] = [0,0],
			width = 200, height = 100,
			name?: string,
			text = '',
			dataset?: $giper_baza_link,
			// Supply a semantic slot when one batch intentionally creates several
			// widgets with otherwise identical arguments.
			creation_slot = '',
			// Stable, idempotent initialization before visible list membership.
			initialize?: ( widget: $shm_hitalama_map_widget )=> void,
		) {
			const fiber = $mol_wire_auto()
			const fiber_object = fiber && ( typeof fiber === 'object' || typeof fiber === 'function' )
				? fiber as unknown as object
				: null
			const active = $shm_hitalama_map_widget_add_active.get( this.link().str )
				?? this.widget_add_batch_current
			if( active && fiber_object ) $shm_hitalama_map_widget_add_fibers.set( fiber_object, active )
			const batch = active ?? ( fiber_object ? $shm_hitalama_map_widget_add_fibers.get( fiber_object ) : null )
			const slot_key = creation_slot || JSON.stringify([
				type,
				[ ... pos ],
				width,
				height,
				name ?? '',
				dataset?.str ?? '',
				$mol_hash_string( text ),
			])
			let state = batch?.slots.get( slot_key ) ?? null
			if( batch && !state ) {
				state = this.widget_add_state( name )
				batch.slots.set( slot_key, state )
			}
			const action = this.widget_add_apply
			const apply = batch ? ( action as any ).orig ?? action : action
			// Keep each batch item as its own task: a completed item's fast path
			// must not remove child tasks from the enclosing action's replay order.
			return batch
				? $mol_wire_sync( apply ).call( this, type, pos, width, height, name, text, dataset, state, initialize )
				: apply.call( this, type, pos, width, height, name, text, dataset, state, initialize )
		}

		@ $mol_action
		private widget_add_apply(
			type: $shm_hitalama_map_widget_def_type_name,
			pos: readonly [number, number] | readonly number[],
			width: number,
			height: number,
			name: string | undefined,
			text: string,
			dataset: $giper_baza_link | undefined,
			state: $shm_hitalama_map_widget_add_state | null,
			initialize?: ( widget: $shm_hitalama_map_widget )=> void,
		) {
			// Creation state belongs to this command, not to an optional history
			// context (geometry/edit/silence can deliberately bypass one). Resolve
			// its stable task on every replay, outside the retained transaction closure.
			const creation = state ?? $mol_wire_sync( this.widget_add_state ).call( this, name )
			return $shm_hitalama_map_history.transaction( this, 'Добавление виджета', ()=> {
				const state = creation
				if( !state ) return
				if( name ) {
					const existing = this.widget_by_title( name )
					// Linking a name precedes publishing the fully configured widget. On a
					// wire restart this can be our own draft, not an older widget.
					if( existing && existing.link().str !== state.widget?.link().str ) {
						state.widget = existing
						state.done = true
						return existing
					}
				}
				if( state.done ) return state.widget
				// Keep the memoized draft read in the same dependency slot on replay.
				// Skipping it after assignment displaces the suspended initializer.
				const widget = state.make()
				state.widget = widget
				if( !widget ) return widget

				// Naming is a command snapshot, not a reactive value changed by publication.
				const title = $mol_wire_sync( state ).title( type )
				$shm_hitalama_map_history.silence( ()=> {
					const time = this.now().valueOf()
					widget?.Created_at(null)?.val( time )
					this.Changed_at(null)?.val( time )

					widget?.text_crdt_disabled( true )

					$mol_wire_sync( widget ).Map( null )?.remote( this )
					widget?.render_data_patch({
						title,
						type,
						text,
						body_x: pos[0],
						body_y: pos[1],
						right_edge_x: width,
						bottom_edge_y: height,
						opacity: 1,
					})
					if( dataset ) widget?.Dataset( null )?.val( dataset )
					if( [ 'table', 'table2', 'table_novirt', 'tabulator' ].includes( type ) ) {
						widget?.table().Map( null )?.remote( this )
					}
					if( [ 'chart', 'echarts' ].includes( type ) ) {
						widget?.table().Map( null )?.remote( this )
						widget?.chart().Widget( null )?.remote( widget )
					}
					if( type === 'group' ) {
						this.border_preset( widget, 'var(--mol_theme_line)', 2, 'dashed' )
					}
					if( initialize ) $mol_wire_sync( initialize )( widget )
					// Name lookup must not expose a draft rejected by its initializer.
					this.Widget_by_name(null)?.key( title, 'auto' )?.remote( widget )
				} )
				const list = state.list()
				if( !list.has( widget.link() ) ) list.splice([ widget.link() ])
				if( widget ) $shm_hitalama_map_history.capture( this, {
					type: 'widget_add',
					target: widget.link().str,
					before: true,
					after: false,
					meta: { title: widget.title(), type: widget.type() },
				}, 'Добавление виджета' )
				state.done = true
				return widget
			} )
		}

		border_preset(
			widget: $shm_hitalama_map_widget | null | undefined,
			color: string,
			width: number,
			style: string,
		) {
			widget?.border_color( color )
			widget?.border_width( width )
			widget?.border_style( style )
		}

		@ $mol_action
		widget_cut( link: $giper_baza_link ) {
			return this.widgets_cut_apply( $mol_wire_sync( this ).widget_cut_prepare( link ), 'Удаление виджета' )
		}

		widget_cut_prepare( link: $giper_baza_link ) {
			return this.widgets_cut_prepare([ link ])
		}

		@ $mol_action
		widgets_cut( links: readonly $giper_baza_link[] ) {
			return this.widgets_cut_apply( $mol_wire_sync( this ).widgets_cut_prepare( links ), 'Удаление виджетов' )
		}

		/** Complete all potentially suspended reads before changing visible membership. */
		widgets_cut_prepare( links: readonly $giper_baza_link[] ) {
			const live = this.Widgets_list()
			const live_links = live?.items() ?? []
			const active = new Set( live_links.map( link => link.str ) )
			const live_widgets = new Map( live_links.map( link => [ link.str, this.widget_by_link( link ) ] ) )
			const children = new Map< string, $shm_hitalama_map_widget[] >
			const child_add = ( parent_id: string, child: $shm_hitalama_map_widget )=> {
				if( !active.has( parent_id ) || !active.has( child.link_str() ) || parent_id === child.link_str() ) return
				const list = children.get( parent_id ) ?? []
				if( !list.some( item => item.link_str() === child.link_str() ) ) list.push( child )
				children.set( parent_id, list )
			}
			for( const parent of live_widgets.values() ) {
				for( const child of this.widget_children_stored( parent ) ) child_add( parent.link_str(), child )
			}
			for( const child of live_widgets.values() ) {
				const parent_id = child.container_widget()?.link_str()
				if( parent_id ) child_add( parent_id, child )
			}
			const result: $shm_hitalama_map_widget_cut_item[] = []
			const visited = new Set< string >
			const visit = ( widget: $shm_hitalama_map_widget )=> {
				const id = widget.link().str
				if( visited.has( id ) || !active.has( id ) ) return
				visited.add( id )
				for( const child of children.get( id ) ?? [] ) visit( child )
				const files = widget.file_links()
				result.push({
					widget,
					container: widget.container_widget()?.link().str ?? '',
					files,
					title: widget.title(),
					type: widget.type(),
				})
			}
			for( const link of links ) if( active.has( link.str ) ) visit( this.widget_by_link( link ) )
			if( !result.length ) return null
			const removed = this.Widgets_removed_list(null)!
			const removed_links = new Set( removed.items().map( link => link.str ) )
			const deleting = new Set( result.map( item => item.widget.link_str() ) )
			// One scan of live containers, never opening historical removed widgets.
			const detached = live_links.filter( link => !deleting.has( link.str ) ).flatMap( link => {
				const widget = this.widget_by_link( link )
				const children = this.widget_children_stored( widget )
				if( !children.some( child => deleting.has( child.link_str() ) ) ) return []
				return [{ widget, children: children.filter( child => !deleting.has( child.link_str() ) ) as $shm_hitalama_map_widget[] }]
			})
			const files = this.Files(null)
			files?.items()
			const names = this.Widget_by_name(null)
			const named = result.flatMap( item => {
				const ref = names?.key( item.title )
				return ref?.remote()?.link_str() === item.widget.link_str() ? [ ref ] : []
			})
			return { result, live: live!, removed, deleting, detached, files, named,
				add: result.map( item => item.widget.link() ).filter( link => !removed_links.has( link.str ) ),
				keep: live_links.filter( link => !deleting.has( link.str ) ),
				count: live_links.length,
			}
		}

		private widgets_cut_apply( plan: ReturnType< $shm_hitalama_map['widgets_cut_prepare'] >, title: string ) {
			if( !plan ) return
			return $shm_hitalama_map_history.transaction( this, title, ()=> {
				for( const { widget, children } of plan.detached ) widget.widgets( children )
				for( const item of plan.result ) {
					if( item.container && !plan.deleting.has( item.container ) ) item.widget.container_widget(null)
					for( const file of item.files ) plan.files?.cut( file )
					$shm_hitalama_map_history.capture( this, {
						type: 'widget_remove', target: item.widget.link_str(), before: false, after: true,
						meta: { title: item.title, type: item.type,
							...item.files.length ? { files: item.files.map( file => file.str ) } : {},
						},
					}, title )
				}
				for( const ref of plan.named ) ref.remote(null)
				// Publish the whole batch in one synchronous turn after preflight.
				plan.removed.splice( plan.add, 0, 0 )
				plan.live.splice( plan.keep, 0, plan.count )
			})
		}

		@ $mol_action
		widget_detach( link: $giper_baza_link, excluded = new Set< string > ) {
			const containers = [
				...( this.Widgets_list()?.remote_list() ?? [] ),
				...( this.Widgets_removed_list()?.remote_list() ?? [] ),
			]
			const checked = new Set<string>()

			for( const container of containers ) {
				if( checked.has( container.link_str() ) ) continue
				checked.add( container.link_str() )
				if( excluded.has( container.link_str() ) ) continue
				if( container.link_str() == link.str ) continue
				if( !container.widgets().some( ( inner: $shm_hitalama_map_widget ) => inner.link().str == link.str ) ) continue

				container.widgets( container.widgets().filter( widget => widget.link().str !== link.str ) )
			}
		}

		@ $mol_action
		widget_restore( link: $giper_baza_link ) {
			return $shm_hitalama_map_history.transaction( this, 'Восстановление виджета', ()=> {
				const widget = this.widget_by_link(link)
				if( !widget.removed() ) return

				this.Widgets_list(null)?.add( link )
				this.Widgets_removed_list(null)?.cut( link )
				$shm_hitalama_map_history.capture( this, {
					type: 'widget_add',
					target: widget.link().str,
					before: true,
					after: false,
					meta: { title: widget.title(), type: widget.type() },
				}, 'Восстановление виджета' )
			} )
		}

		@ $mol_mem
		search_statistics() {
			return this.Search_statistics()?.remote_list() ?? []
		}

		viewport_frames() {
			return this.Widgets_list()?.remote_list().filter( ( b: $shm_hitalama_map_widget ) => b.type() == 'viewport_frame' ) ?? []
		}

		@ $mol_mem
		components_by_name() {
			const widgets: Record< string, $shm_hitalama_map_widget > = {}
			this.Widgets_list()?.remote_list().forEach( ( b: $shm_hitalama_map_widget ) => {
				if( b.type() == 'component' ) {
					const name = b.Component()?.remote()?.class_name()
					if( !name ) return
					if( widgets[ name ]?.component().version() > b.component().version() ) return
					widgets[ name ] = b
				}
			} )
			return widgets
		}

		@ $mol_mem
		component_css() {
			return this.Widgets_list()?.remote_list().find( ( b: $shm_hitalama_map_widget ) => {
				if( b.type() == 'code_css' && b.Component()?.remote() ) return true
			} )
		}

		@ $mol_action
		search_statistics_cut( index: number ) {
			this.Search_statistics()?.wipe( index )
		}

		@ $mol_mem
		serialized() {
			return this.serialize()
		}

		@ $mol_mem
		get_transfer() {
			$mol_wire_solid()
			return $shm_hitalama_transfer_map.make({
				$: this.$,
				map: ()=> this
			})
		}

		@ $mol_mem
		get_restorer() {
			$mol_wire_solid()
			return $shm_hitalama_transfer_map_restorer.make({
				map: ()=> this,
			})
		}

		serialize(): $shm_hitalama_transfer_map_dump {
			const transfer = this.get_transfer()
			return transfer.serialize_map()
		}

		serialize_without_files(): $shm_hitalama_transfer_map_dump {
			const transfer = $shm_hitalama_transfer_map.make({
				map: ()=> this,
				include_files: ()=> false,
			})
			return transfer.serialize_map()
		}

		serialize_widgets( widgets: $shm_hitalama_map_widget[] ): $shm_hitalama_transfer_map_widgets_dump {
			const transfer = this.get_transfer()
			return transfer.serialize_widgets( widgets )
		}

		@ $mol_action
		deserialize_widgets( dto: $shm_hitalama_transfer_map_widgets_dump ) {
			return $shm_hitalama_map_history.transaction( this, 'Вставка виджетов', ()=> {
				const before = new Set(
					this.Widgets_list()?.remote_list().map( ( widget: $shm_hitalama_map_widget )=> widget.link_str() ) ?? [],
				)
				const transfer = this.get_transfer()
				transfer.deserialize_widgets( dto )
				for( const widget of this.Widgets_list()?.remote_list() ?? [] ) {
					if( before.has( widget.link_str() ) ) continue
					$shm_hitalama_map_history.capture( this, {
						type: 'widget_add',
						target: widget.link_str(),
						before: true,
						after: false,
						meta: { title: widget.title(), type: widget.type() },
					}, 'Вставка виджетов' )
				}
			} )
		}

		@ $mol_action
		restore_widgets( dto: $shm_hitalama_transfer_map_widgets_dump ) {
			const restorer = this.get_restorer()
			restorer.deserialize_widgets( dto )
		}

		@ $mol_mem
		get_map_transfer() {
			$mol_wire_solid()
			return $shm_hitalama_map_transfer.make({
				map: ()=> this
			})
		}

		@ $mol_action
		deserialize( dto: $shm_hitalama_transfer_map_dump | any ) {
			if(
				dto
				&& typeof dto === 'object'
				&& !Array.isArray( dto )
				&& !('nodes' in dto)
				&& (
					Array.isArray( dto.blocks )
					|| Array.isArray( dto.widgets )
					|| Array.isArray( dto.tables )
					|| Array.isArray( dto.files )
				)
			) {
				const transfer = this.get_map_transfer()
				transfer.deserialize( dto )
				return
			}

			const transfer = this.get_transfer()
			transfer.deserialize_map( dto )
		}

		@ $mol_action
		restore( dto: $shm_hitalama_transfer_map_dump ) {
			const restorer = this.get_restorer()
			restorer.deserialize_map( dto )
		}
		
	}

}
